import React, { Component, Fragment } from 'react';
import Breadcrumb from '../common/breadcrumb';
import AuthService from "../services/auth.service";
import ApiService from "../services/api.service";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';

const required = value => {
    if (!value) {
      return (
        <div className="alert alert-danger" role="alert">
          Este campo es obligatorio!
        </div>
      );
    }
  };

export class Ver_add_campaign_promotion extends Component {
    constructor(props) {
        super(props);
        this.handleSave = this.handleSave.bind(this);
        this.onChangeTitle = this.onChangeTitle.bind(this);
        this.onChangeDescription = this.onChangeDescription.bind(this);
        this.onChangeImage = this.onChangeImage.bind(this);
        this.onChangeCtaText = this.onChangeCtaText.bind(this);
        this.onChangeCtaUrl = this.onChangeCtaUrl.bind(this);
        this.onChangeValidFrom = this.onChangeValidFrom.bind(this);
        this.onChangeValidUntil = this.onChangeValidUntil.bind(this);

        this.state = {
            id_campaign: null,
            promotion_title: "",
            promotion_description: "",
            promotion_image: "",
            call_to_action_text: "Ver promoción",
            call_to_action_url: "",
            valid_from: "",
            valid_until: "",
            campaignData: null,
            errors: {},
            loading: false,
        }
    }

    componentWillMount() {
        let id_campaign = this.props.match.params.id_campaign;
        this.setState({ id_campaign: id_campaign });
        this.getCampaignData(id_campaign);
    }

    getCampaignData(id_campaign){
        var user = AuthService.getCurrentUser();
        ApiService.getWhatsappCampaignDetails(user.token, id_campaign).then(
            (res) => {
                if(res && res.status === 'success')
                {
                    this.setState({ campaignData: res.data });
                }
            },
            error => {
              toast.error("Error al cargar la campaña");
            }
          );
    }

    onChangeTitle(e) {
        this.setState({
            promotion_title: e.target.value
        });
    }

    onChangeDescription(e) {
        this.setState({
            promotion_description: e.target.value
        });
    }

    onChangeImage(e) {
        this.setState({
            promotion_image: e.target.value
        });
    }

    onChangeCtaText(e) {
        this.setState({
            call_to_action_text: e.target.value
        });
    }

    onChangeCtaUrl(e) {
        this.setState({
            call_to_action_url: e.target.value
        });
    }

    onChangeValidFrom(e) {
        this.setState({
            valid_from: e.target.value
        });
    }

    onChangeValidUntil(e) {
        this.setState({
            valid_until: e.target.value
        });
    }

    handleSave(e) {
        e.preventDefault();

        this.form.validateAll();

        if (this.checkBtn.context._errors.length === 0) {
            this.setState({
                message: "",
                loading: true
            });

            var user = AuthService.getCurrentUser();
            let data_promotion = {
                'id_campaign': this.state.id_campaign,
                'promotion_title': this.state.promotion_title,
                'promotion_description': this.state.promotion_description,
                'promotion_image': this.state.promotion_image,
                'call_to_action_text': this.state.call_to_action_text,
                'call_to_action_url': this.state.call_to_action_url,
                'valid_from': this.state.valid_from || null,
                'valid_until': this.state.valid_until || null,
            }

            ApiService.postCampaignPromotion(user.token, data_promotion).then(
            (res) => {
                if(res){
                    if(res.status == 'success')
                    {
                        this.props.history.push(`/campaign-promotions/${this.state.id_campaign}`);
                        toast.success("Promoción creada!");
                    }
                    else
                    {
                        toast.error(res.message);
                        this.setState({
                            loading: false
                        });
                    }
                }else{
                    this.setState({
                        loading: false
                    });
                }
            },
            error => {
              const resMessage =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
              this.setState({
                loading: false
              });
              toast.error("Ha ocurrido un error!");
            }
          );
        }
    }

    render() {
        const { campaignData } = this.state;

        return (
            <Fragment>
                <Breadcrumb title="Crear Promoción de Campaña" parent="Promociones" />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <h5>Agregar Promoción{campaignData ? ` a: ${campaignData.campaign_name}` : ''}</h5>
                                </div>
                                <div className="card-body">
                                {campaignData && (
                                    <div className="alert alert-info mb-3">
                                        <strong>Importante:</strong> Esta promoción se mostrará en la web cuando los usuarios del grupo "{campaignData.Cluster ? campaignData.Cluster.cluster_name : 'Sin grupo'}" ingresen después de recibir el mensaje de WhatsApp.
                                    </div>
                                )}
                                <Form
                                    onSubmit={this.handleSave}
                                    ref={c => {
                                        this.form = c;
                                    }}
                                >
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-md-4"><span>*</span> Título de la Promoción</label>
                                        <div className="col-md-7">
                                            <Input
                                                type="text"
                                                className="form-control"
                                                name="promotion_title"
                                                placeholder="Ej: 20% de descuento en frutas frescas"
                                                value={this.state.promotion_title}
                                                onChange={this.onChangeTitle}
                                                validations={[required]}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-md-4"><span>*</span> Descripción</label>
                                        <div className="col-md-7">
                                            <textarea
                                                className="form-control"
                                                name="promotion_description"
                                                rows="4"
                                                placeholder="Describe los detalles de la promoción..."
                                                value={this.state.promotion_description}
                                                onChange={this.onChangeDescription}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-md-4">URL de la Imagen</label>
                                        <div className="col-md-7">
                                            <Input
                                                type="text"
                                                className="form-control"
                                                name="promotion_image"
                                                placeholder="https://ejemplo.com/imagen.jpg"
                                                value={this.state.promotion_image}
                                                onChange={this.onChangeImage}
                                            />
                                            <small className="form-text text-muted">
                                                Opcional. URL de la imagen promocional.
                                            </small>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-md-4"><span>*</span> Texto del Botón (CTA)</label>
                                        <div className="col-md-7">
                                            <Input
                                                type="text"
                                                className="form-control"
                                                name="call_to_action_text"
                                                placeholder="Ej: Ver promoción, Comprar ahora, etc."
                                                value={this.state.call_to_action_text}
                                                onChange={this.onChangeCtaText}
                                                validations={[required]}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-md-4">URL del Botón</label>
                                        <div className="col-md-7">
                                            <Input
                                                type="text"
                                                className="form-control"
                                                name="call_to_action_url"
                                                placeholder="https://ejemplo.com/promocion"
                                                value={this.state.call_to_action_url}
                                                onChange={this.onChangeCtaUrl}
                                            />
                                            <small className="form-text text-muted">
                                                Opcional. URL a la que dirigirá el botón.
                                            </small>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-md-4">Válido Desde</label>
                                        <div className="col-md-7">
                                            <Input
                                                type="datetime-local"
                                                className="form-control"
                                                name="valid_from"
                                                value={this.state.valid_from}
                                                onChange={this.onChangeValidFrom}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-md-4">Válido Hasta</label>
                                        <div className="col-md-7">
                                            <Input
                                                type="datetime-local"
                                                className="form-control"
                                                name="valid_until"
                                                value={this.state.valid_until}
                                                onChange={this.onChangeValidUntil}
                                            />
                                        </div>
                                    </div>
                                    <div className="pull-right">
                                        <button
                                            type="submit"
                                            className="btn btn-primary"
                                            disabled={this.state.loading}
                                        >
                                            {this.state.loading && (
                                            <span className="spinner-border spinner-border-sm"></span>
                                            )}
                                            Guardar
                                        </button>
                                    </div>
                                    <CheckButton
                                        style={{ display: "none" }}
                                        ref={c => {
                                        this.checkBtn = c;
                                        }}
                                    />
                                </Form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ToastContainer />
            </Fragment>
        )
    }
}

export default Ver_add_campaign_promotion
